;(function(window, document, undefined) {
  'use strict';
var Deferred = (function(){
  Promise.settle = function(promisesArr){
    var reflectedArr = promisesArr.map(function(promise){
      return promise.then(function(successResult){
        return {
          result: successResult,
          status: 'resolved'
        };
      },function(errorResult){
        return {
          result: errorResult,
          status: 'rejected'
        };
      });
    });
    return Promise.all(reflectedArr);
  };
  
  function Deferred(){
    var def = this;
    /**
     * @instance
     * @memberof Flybits.Deferred
     * @member {external:Promise} promise Instance of an ES6 Promise to be fulfilled.
     */
    this.promise = new Promise(function(resolve,reject){
      /**
       * @instance
       * @memberof Flybits.Deferred
       * @member {function} resolve Callback to be invoked when the asychronous task that initiated the promise is successfully completed.
       */
      def.resolve = resolve;
      /**
       * @instance
       * @memberof Flybits.Deferred
       * @member {function} reject Callback to be invoked when the asychronous task that initiated the promise has failed to complete successfully.
       */
      def.reject = reject;
    });

    this.then = this.promise.then.bind(this.promise);
    this.catch = this.promise.catch.bind(this.promise);
  }

  return Deferred;
})();

var Validation = (function(){
  function Validation(){
    this.state = true;
    this.errors = [];

    this.stacktrace = "";

    this.setStackTrace();
  }

  Validation.prototype = {
    addError: function(header,message,detailsObj){
      this.state = false;
      var retObj = {
        header: header,
        message: message
      };
      if(detailsObj){
        retObj.context = detailsObj.context;
        retObj.code = detailsObj.code;
        retObj.serverCode = detailsObj.serverCode;
      }
      this.errors.push(retObj);

      return this;
    },
    firstError: function(){
      if(this.errors.length > 0){
        return this.errors[0];
      }
      return null;
    },
    setStackTrace: function(){
      var flyError = new Error();
      flyError.name = "FlybitsError";
      this.stacktrace = flyError.stack;
      if(this.stacktrace){
        this.stacktrace = this.stacktrace.split('\n').filter(function(str){
          return str.indexOf('Validation') < 0;
        }).join('\n');
      }
      return this;
    }
  };

  Validation.prototype.type = Validation.type = {};
  Validation.prototype.type.MALFORMED = Validation.type.MALFORMED = 1000;
  Validation.prototype.type.INVALIDARG = Validation.type.INVALIDARG = 1001;
  Validation.prototype.type.MISSINGARG = Validation.type.MISSINGARG = 1002;
  Validation.prototype.type.NOTFOUND = Validation.type.NOTFOUND = 1003;
  Validation.prototype.type.CONNECTIONERROR = Validation.type.CONNECTIONERROR = 1004;
  Validation.prototype.type.UNAUTHENTICATED = Validation.type.UNAUTHENTICATED = 1005;
  Validation.prototype.type.RETRIEVALERROR = Validation.type.RETRIEVALERROR = 1006;
  Validation.prototype.type.NOTSUPPORTED = Validation.type.NOTSUPPORTED = 1007;
  Validation.prototype.type.UNEXPECTED = Validation.type.UNEXPECTED = 1008;

  return Validation;
})();

var LoadingView = Vue.extend({
  template:'#view-loading',
});
Vue.component('loading-view',LoadingView);
var LoaderBar = Vue.extend({
  template:'#loader-bar',
});
Vue.component('loader-bar',LoaderBar);

var JsonDisplay = Vue.extend({
  template:'#json-display',
  props: {
    object: Object
  },
  computed: {
    str: function(){
      if(!this.object){
        return '';
      }
      var str = JSON.stringify(this.object, undefined, 2);
      str = this.syntaxHighlight(str);
      return str;
    }
  },
  methods: {
    syntaxHighlight: function(str){
      str = str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      return str.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
          var cls = 'number';
          if (/^"/.test(match)) {
              if (/:$/.test(match)) {
                  cls = 'key';
              } else {
                  cls = 'string';
              }
          } else if (/true|false/.test(match)) {
              cls = 'boolean';
          } else if (/null/.test(match)) {
              cls = 'null';
          }
          return '<span class="' + cls + '">' + match + '</span>';
      });
    }
  }
});
Vue.component('json-display',JsonDisplay);

var ContentTile = (function(){
  var recursiveFetch = function(pagedData, deferred){
    if(pagedData.hasNext()){
      pagedData.getNext().then(function(){
        recursiveFetch(pagedData,deferred);
      });
    } else{
      deferred.resolve();
    }
  };

  return Vue.extend({
    template:'#content-tile',
    props: {
      content: Object
    },
    data: function(){
      return {
        obj: null
      };
    },
    watch: {
      content: function(newVal, oldVal){
        this.render();
      }
    },
    methods: {
      render: function(){
        var view = this;
        if(this.content){
          this.content.getData().then(function(obj){
            if(!obj){
              return;
            }
            
            var pagedKeys = Object.keys(obj).filter(function(key){
              return obj[key] instanceof Flybits.PagedData;
            });
            
            if(pagedKeys.length){
              var promises = pagedKeys.map(function(key){
                return view.getAllPages(obj[key]);
              });
              Promise.settle(promises).then(function(){
                view.obj = obj;
              });
            } else{
              view.obj = obj;
            }
          });
        }
      },
      getAllPages: function(pagedData){
        var def = new Flybits.Deferred();
        recursiveFetch(pagedData, def);
        return def.promise;
      }
    },
    mounted: function(){
      this.render();
    }
  });
})();
Vue.component('content-tile',ContentTile);

var ContentTile = (function(){
  var recursiveFetch = function(pagedData, deferred){
    if(pagedData.hasNext()){
      pagedData.getNext().then(function(){
        recursiveFetch(pagedData,deferred);
      });
    } else{
      deferred.resolve();
    }
  };

  return Vue.extend({
    template:'#content-tile',
    props: {
      content: Object
    },
    data: function(){
      return {
        obj: null
      };
    },
    watch: {
      content: function(newVal, oldVal){
        this.render();
      }
    },
    methods: {
      render: function(){
        var view = this;
        if(this.content){
          this.content.getData().then(function(obj){
            if(!obj){
              return;
            }
            
            var pagedKeys = Object.keys(obj).filter(function(key){
              return obj[key] instanceof Flybits.PagedData;
            });
            
            if(pagedKeys.length){
              var promises = pagedKeys.map(function(key){
                return view.getAllPages(obj[key]);
              });
              Promise.settle(promises).then(function(){
                view.obj = obj;
              });
            } else{
              view.obj = obj;
            }
          });
        }
      },
      getAllPages: function(pagedData){
        var def = new Flybits.Deferred();
        recursiveFetch(pagedData, def);
        return def.promise;
      }
    },
    mounted: function(){
      this.render();
    }
  });
})();
Vue.component('content-tile',ContentTile);

var LoadingGears = Vue.extend({
  template:'#loading-gears',
});
Vue.component('loading-gears',LoadingGears);

var ToggleView = Vue.extend({
  template:'#toggle-view',
  props: ['label', 'value'],
  methods: {
    toggle: function(){
      this.$emit('input', !this.value);
    }
  }
});
Vue.component('toggle-view',ToggleView);

var SplashPage = (function(){

  return {
    template: '#splash-page',

  };

})();
Vue.component('splash-page',SplashPage);
var Dashboard = (function(){

  return {
    template:'#dashboard',
    beforeRouteEnter: function(to, from, next){
      next(function(vm){
        vm.init();
        if(App.vm.sessionUser){
          vm.startPoll();
        }
      });
    },
    data: function(){
      return {
        content: [],
        pollTimer: null,
        pollEnabled: false,
        isSettingsOpen: false,
        currentUserID: '',
        currentSyntheticUserID: '',
        currentProjectID: '',
        tmpJWT: '',
        tmpProjectID: '',
        currentJWT: '',
        isPollFlag: true,
      };
    },
    watch: {
      isPollFlag: function(newVal, oldVal){
        if(newVal){
          this.startPoll();
        } else{
          this.stopPoll();
        }
      }
    },
    methods: {
      init: function(){
        var clip = new ClipboardJS(this.$el.querySelectorAll('.modifier'));
        clip.on('success', function(e){
          console.log('e', e);
          App.toast('Copied to clipboard');
        });
      },
      startPoll: function(){
        this.stopPoll();
        this.pollEnabled = true;
        this.poll();
      },
      stopPoll: function(){
        this.pollEnabled = false;
        clearTimeout(this.pollTimer);
      },
      poll: function(){
        var def = new Flybits.Deferred();
        var view = this;
  
        Flybits.api.Content.getAll({
          paging: {
            limit: 9999999
          }
        }).then(function(res){
          view.content = res.result;
        }).catch(function(e){
          def.reject(e);
        }).then(function(){
          if(view.pollEnabled){
            view.pollTimer = setTimeout(function(){
              view.poll();
            },App.cfg.POLLINTERVAL);
          }
        });
  
        return def.promise;
      },
      openSettings: function(){
        this.currentProjectID = Flybits.Session._projectID;
        this.currentJWT = Flybits.Session.userToken;
        this.currentUserID = Flybits.Session.user.id;
        this.currentSyntheticUserID = Flybits.Session.user.email;
        this.isSettingsOpen = true;
      },
      cancelSettings: function(){
        this.isSettingsOpen = false;
        this.clearSettings();
      },
      setJWT: function(){
        var view = this;
        App.evt.emit(App.actions.LOADING,true);
        Flybits.Session.setUserToken(this.tmpJWT);
        Flybits.api.User.getSignedInUser().then(function(){
          view.openSettings();
        }).catch(function(e){
          console.log('> error',e);
        }).then(function(){
          App.evt.emit(App.actions.LOADING,false);
        });
        this.content = [];
        this.clearSettings();
      },
      setProject: function(){
        var view = this;
        App.cfg.PROJECTID = this.tmpProjectID;
        App.evt.emit(App.actions.LOADING,true);
        App.initializeAnonymousUser().then(function(){
          view.openSettings();
          view.clearSettings();
        }).catch(function(e){
          console.log('> error',e);
        }).then(function(){
          App.evt.emit(App.actions.LOADING,false);
        });
      },
      clearSettings: function(){
        this.tmpJWT = '';
        this.tmpProjectID = '';
      }
    }
  };

})();
Vue.component('dashboard',Dashboard);
var App = (function(){
  var deferredReady = new Deferred();

  var App = {
    ready: deferredReady.promise,
    vm: null,
    evt: null,
    ext:{
      CONFIG:"res/config.json",
      VERSION: 'version.txt'
    },
    actions:{
      LOADING: "loading",
      CONFIG_UPDATE: "configupdated"
    },
    cfg: {},
    util: {},
    initConfig:function(){
      var app = this;
      var def = new Deferred();

      fetch(this.ext.CONFIG).then(function(resp){
        if(resp.status !== 200){
          throw new Validation().addError("Configuration file not found","Reverting to default configuration. No configuration found at:"+app.ext.CONFIG,{
            code: Flybits.Validation.type.MISSINGARG
          });
        }
        return resp.json();
      }).then(function(json){
        app.cfg = App.util.Obj.extend(app.cfg,json.defaults);
        app.vm.isDebug = app.cfg.debug;
        def.resolve(app.cfg);
      }).catch(function(ex){
        if(ex instanceof Validation){
          def.reject(ex);
        } else{
          def.reject(new Validation().addError("Failed to read configuration file.","Reverting to default configuration. Configuration format incorrect at:"+app.ext.CONFIG,{
            code: Validation.type.MALFORMED
          }));
        }
      });

      return def.promise;
    },
    checkVersion: function(){
      fetch(this.ext.VERSION).then(function(resp){
        return resp.text();
      }).then(function(fileStr){
        console.debug(fileStr);
      });
    },
    initSDK: function(){
      var def = new Flybits.Deferred();
      Flybits.init({
        HOST: this.cfg.HOST,
        CTXREPORTDELAY: this.cfg.CTXREPORTDELAY
      }).then(function(){
        def.resolve();
      });

      return def.promise;
    },
    clearSession: function(){
      this.vm.sessionUser = null;
      Flybits.Session.disconnect();
    },
    login: function(){
      return Flybits.Session.connect(new Flybits.idp.AnonymousIDP({
        projectID: App.cfg.PROJECTID
      }));
    },
    initializeAnonymousUser: function(){
      var def = new Flybits.Deferred();
      App.initSDK().then(function(){
        App.clearSession();
        return App.login();
      }).then(function(){
        App.vm.sessionUser = Flybits.Session.user;
        def.resolve();
      }).catch(function(e){
        def.reject(e);
      });

      return def.promise;
    },
    startup: function(){
      deferredReady.resolve();
      App.router.replace('dashboard');
    },
    toast: function(msg, msgType){
      msgType = msgType || 'normal';
      var opt = {
        text: msg,
        gravity: 'bottom'
      };
      if(msgType === 'error'){
        opt.backgroundColor = '#b20000';
      }

      Toastify(opt).showToast();
    },
  };

  var router = App.router = new VueRouter({
    routes: [{
      path: '/',
      name: 'splash',
      component: SplashPage,
      alias: '/splash'
    },{
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
    }]
  });

  App.vm = new Vue({
    router: router,
    el: '.container',
    data: function(){
      return {
        isLoaded: false,
        isLoading: false,
        isCFGLoaded: false,
        errorText: '',
        sessionUser: null
      };
    },
    computed: {
    },
    watch: {
    },
    methods: {
      refreshApp: function(){
        window.location.reload();
      }
    },
    mounted: function(){
      this.isLoaded = true;
      window.App = App;
    },
  });
  
  /**
   * Resusing the Vue event emitter interface but keeping it generic so we can
   * swap it out for our favourite event emitter if we ever need to.
   */
  App.vm.on = App.vm.$on;
  App.vm.emit = App.vm.$emit;
  App.evt = App.vm;

  var loaderStack = [];
  var loadStart = 0;
  App.evt.on(App.actions.LOADING,function(bool, noDelay){
    if(bool){
      App.vm.isLoading = true;
      if(loaderStack.length <= 0){
        loadStart = new Date().getTime();
      }
      loaderStack.push(true);
    } else if(!bool && loaderStack.length > 1){
      loaderStack.pop();
    } else if(!bool){
      loaderStack.pop();
      var now = new Date().getTime();
      if(now - loadStart < 300 && !noDelay){
        setTimeout(function(){
          App.vm.isLoading = false;
        },300);
      } else{
        App.vm.isLoading = false;
      }
    }
  });

  return App;
})();

App.router.replace('/');
App.checkVersion();

App.initConfig().then(function(){
  return App.initializeAnonymousUser();
}).then(function(){
  App.startup();
}).catch(function(e){
  console.log('> initialiaation failed', e);
});
App.util.Obj = (function(){
  var s4 = function(){
    return Math.floor((1 + Math.random()) * 0x10000)
               .toString(16)
               .substring(1);
  };
  
  var Obj = {
    guid:function(tuples){
      var str = 'js';
      if(tuples && tuples > 0){
        for(var i = 0; i < tuples; i++){
          str += str !== 'js'?'-'+s4():s4();
        }
        return str;
      }
      return 'js' + s4() + s4() + '-' + s4() + '-' + s4() + '-' +
           s4() + '-' + s4() + s4() + s4();
    },zero2Pad: function(num){
      return ('0'+num).slice(-2);
    },
    removeObject:function(arr,obj,findCallback){
      var index = arr.indexOf(obj);

      if(findCallback){
        var objs = arr.filter(findCallback);
        if(objs.length > 0){
          index = arr.indexOf(objs[0]);
        }
      }

      if(index >= 0){
        return arr.splice(index,1);
      }
      return arr;
    },
    difference: function(currentSource, sourceOfTruth){
      var diff = [];

      for(var i = 0; i < currentSource.length; i++){
        if(sourceOfTruth.indexOf(currentSource[i]) < 0){
          diff.push(currentSource[i]);
        }
      }
      return diff;
    },
    intersection: function(currentSource, sourceOfTruth){
      var union = [];

      for(var i = 0; i < currentSource.length; i++){
        if(sourceOfTruth.indexOf(currentSource[i]) > -1){
          union.push(currentSource[i]);
        }
      }
      return union;
    }
  };

  Obj.extend = (function(){
    function isMergeableObject(val) {
      var nonNullObject = val && typeof val === 'object';

      return nonNullObject && Object.prototype.toString.call(val) !== '[object RegExp]' && Object.prototype.toString.call(val) !== '[object Date]';
    }

    function emptyTarget(val) {
      return Array.isArray(val) ? [] : {};
    }

    function cloneIfNecessary(value, optionsArgument) {
      var clone = optionsArgument && optionsArgument.clone === true;
      return (clone && isMergeableObject(value)) ? deepmerge(emptyTarget(value), value, optionsArgument) : value;
    }

    function defaultArrayMerge(target, source, optionsArgument) {
      var destination = target.slice();
      source.forEach(function (e, i) {
        if (typeof destination[i] === 'undefined') {
          destination[i] = cloneIfNecessary(e, optionsArgument);
        } else if (isMergeableObject(e)) {
          destination[i] = deepmerge(target[i], e, optionsArgument);
        } else if (target.indexOf(e) === -1) {
          destination.push(cloneIfNecessary(e, optionsArgument));
        }
      });
      return destination;
    }

    function mergeObject(target, source, optionsArgument) {
      var destination = {};
      if (isMergeableObject(target)) {
        Object.keys(target).forEach(function (key) {
          destination[key] = cloneIfNecessary(target[key], optionsArgument);
        });
      }
      Object.keys(source).forEach(function (key) {
        if (!isMergeableObject(source[key]) || !target[key]) {
          destination[key] = cloneIfNecessary(source[key], optionsArgument);
        } else {
          destination[key] = deepmerge(target[key], source[key], optionsArgument);
        }
      });
      return destination;
    }

    function deepmerge(target, source, optionsArgument) {
      var array = Array.isArray(source);
      var options = optionsArgument || { arrayMerge: defaultArrayMerge };
      var arrayMerge = options.arrayMerge || defaultArrayMerge;

      if (array) {
        return Array.isArray(target) ? arrayMerge(target, source, optionsArgument) : cloneIfNecessary(source, optionsArgument);
      } else {
        return mergeObject(target, source, optionsArgument);
      }
    }

    deepmerge.all = function deepmergeAll(array, optionsArgument) {
      if (!Array.isArray(array) || array.length < 2) {
        throw new Error('first argument should be an array with at least two elements');
      }

      // we are sure there are at least 2 values, so it is safe to have no initial value
      return array.reduce(function (prev, next) {
        return deepmerge(prev, next, optionsArgument);
      });
    };

    return deepmerge;
  })();

  return Obj;
})();
App.util.Api = (function(){
  var defaultAjaxOpts = {
    method: 'GET',
    headers: {}
  };

  var Api = {
    fetch: function(url,opts){
      opts = opts || {};
      opts.respType = opts.respType || 'json';
      var def = new Deferred();
      
      var ajaxOpts = ObjUtil.extend({},defaultAjaxOpts);
      var isJSON = opts.respType === 'json';
      delete opts.respType;
      ObjUtil.extend(ajaxOpts,opts);

      fetch(url,ajaxOpts).then(this.checkResult).then(this.getResultBody)
        .then(function(respObj){
          if(isJSON){
            try{
              respObj.body = api.parseResponse(respObj.body);
              def.resolve(respObj);
            } catch(e){
              def.reject(new Validation().addError("Request Failed","Unexpected server response.",{
                code: Validation.type.MALFORMED,
              }));
            }
          } else{
            def.resolve(respObj);
          }
        }).catch(function(resp){
          api.getResultBody(resp).then(function(resultObj){
            var parsedResp = api.parseErrorMsg(resultObj.body);
            def.reject(new Validation().addError('Request error',parsedResp,{
              serverCode: resp.status
            }));
          });
        });

      return def.promise;
    },
    checkResult: function(resp){
      if(resp.status >= 200 && resp.status < 300){
        return resp;
      }
      throw resp;
    },
    getResultBody: function(resp){
      var def = new Deferred();
      if(resp && resp.text){
        var respHeaders = {};
        resp.headers.forEach(function(val,key){
          respHeaders[key] = val;
        });
        resp.text().then(function(str){
          def.resolve({
            body: str,
            headers: respHeaders
          });
        }).catch(function(e){
          def.reject(e);
        });
      } else{
        def.resolve({
          body: "",
          headers: {}
        });
      }

      return def.promise;
    },
    getResultJSON: function(resp){
      return resp.json();
    },
    htmlEncode:function(value){
      /*global encodeURIComponent*/
      return encodeURIComponent(value);
    },
    htmlDecode:function(str){
      return str.replace(/&#?(\w+);/g, function(match, dec) {
        if(isNaN(dec)) {
          chars = {quot: 34, amp: 38, lt: 60, gt: 62, nbsp: 160, copy: 169, reg: 174, deg: 176, frasl: 47, trade: 8482, euro: 8364, Agrave: 192, Aacute: 193, Acirc: 194, Atilde: 195, Auml: 196, Aring: 197, AElig: 198, Ccedil: 199, Egrave: 200, Eacute: 201, Ecirc: 202, Euml: 203, Igrave: 204, Iacute: 205, Icirc: 206, Iuml: 207, ETH: 208, Ntilde: 209, Ograve: 210, Oacute: 211, Ocirc: 212, Otilde: 213, Ouml: 214, times: 215, Oslash: 216, Ugrave: 217, Uacute: 218, Ucirc: 219, Uuml: 220, Yacute: 221, THORN: 222, szlig: 223, agrave: 224, aacute: 225, acirc: 226, atilde: 227, auml: 228, aring: 229, aelig: 230, ccedil: 231, egrave: 232, eacute: 233, ecirc: 234, euml: 235, igrave: 236, iacute: 237, icirc: 238, iuml: 239, eth: 240, ntilde: 241, ograve: 242, oacute: 243, ocirc: 244, otilde: 245, ouml: 246, divide: 247, oslash: 248, ugrave: 249, uacute: 250, ucirc: 251, uuml: 252, yacute: 253, thorn: 254, yuml: 255, lsquo: 8216, rsquo: 8217, sbquo: 8218, ldquo: 8220, rdquo: 8221, bdquo: 8222, dagger: 8224, Dagger: 8225, permil: 8240, lsaquo: 8249, rsaquo: 8250, spades: 9824, clubs: 9827, hearts: 9829, diams: 9830, oline: 8254, larr: 8592, uarr: 8593, rarr: 8594, darr: 8595, hellip: 133, ndash: 150, mdash: 151, iexcl: 161, cent: 162, pound: 163, curren: 164, yen: 165, brvbar: 166, brkbar: 166, sect: 167, uml: 168, die: 168, ordf: 170, laquo: 171, not: 172, shy: 173, macr: 175, hibar: 175, plusmn: 177, sup2: 178, sup3: 179, acute: 180, micro: 181, para: 182, middot: 183, cedil: 184, sup1: 185, ordm: 186, raquo: 187, frac14: 188, frac12: 189, frac34: 190, iquest: 191, Alpha: 913, alpha: 945, Beta: 914, beta: 946, Gamma: 915, gamma: 947, Delta: 916, delta: 948, Epsilon: 917, epsilon: 949, Zeta: 918, zeta: 950, Eta: 919, eta: 951, Theta: 920, theta: 952, Iota: 921, iota: 953, Kappa: 922, kappa: 954, Lambda: 923, lambda: 955, Mu: 924, mu: 956, Nu: 925, nu: 957, Xi: 926, xi: 958, Omicron: 927, omicron: 959, Pi: 928, pi: 960, Rho: 929, rho: 961, Sigma: 931, sigma: 963, Tau: 932, tau: 964, Upsilon: 933, upsilon: 965, Phi: 934, phi: 966, Chi: 935, chi: 967, Psi: 936, psi: 968, Omega: 937, omega: 969}
          if (chars[dec] !== undefined){
            dec = chars[dec];
          }
        }
        return String.fromCharCode(dec);
      });
    },
    base64Decode: function(str){
      return decodeURIComponent(Array.prototype.map.call(atob(str), function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
    },
    parseResponse: function(rawResponse){
      return JSON.parse(rawResponse,function(key,val){
        if(typeof val === "string"){
          return api.htmlDecode(val);
        }
        return val;
      });
    },
    parseErrorMsg: function(rawResponse){
      try{
        var resp = this.parseResponse(rawResponse);
      } catch(e){
        return "Malformed server response";
      }
      var msg = null;

      if(resp){
        if(resp.error){
          resp = resp.error;
        }
        
        return resp.messageJSON || resp.exceptionMessage || resp.message || "Unexpected error has occurred";
      }

      return msg;
    }
  };

  return Api;
})();
App.util.Browser = (function(){
  return {
    getCookie: function(key) {
      var value = "; " + document.cookie;
      var parts = value.split("; " + key + "=");
      if (parts.length == 2) {
        return parts.pop().split(";").shift();
      } else{
        return null;
      }
    },
    setCookie: function(key,value,expiryDateObj){
      var expires = "";
      if (expiryDateObj) {
        expires = "; expires=" + expiryDateObj.toGMTString();
      }
      document.cookie = key + "=" + value + expires + "; path=/";
    },
    getURLParam:function(name) {
      name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
      var regexS = "[\\?&]" + name + "=([^&#]*)";
      var regex = new RegExp(regexS);
      var results = regex.exec(window.location.href);
      if (results === null)
        return "";
      else
        return results[1];
    }
  };
})();
})(window, document);